import { useState, useEffect } from 'react';
import { GA_FIELDS_FETCH_ERROR, GA_FIELDS_BASE_URL } from './constants';
import { GAResource, GAFieldsResponse } from './types';
import { apiAuthCaller } from '@services/apiCaller';
import useStores from '@stores/useStores';

export const useGAFields = (resource?: string) => {
  const [fields, setFields] = useState<GAFieldsResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { userStore } = useStores();
  useEffect(() => {
    if (resource) {
      (async () => {
        try {
          setLoading(true);
          const path = GA_FIELDS_BASE_URL(resource);
          const fieldsResponse = await apiAuthCaller(userStore.token, true).get(path);
          setFields(fieldsResponse.data);
        } catch (err: unknown) {
          setError(GA_FIELDS_FETCH_ERROR);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [resource]);
  return {
    fields,
    loading,
    error,
  };
};

export const useGAResources = () => {
  const [resources, setResources] = useState<GAResource[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      const GAQLresources = await import('./resources.json');
      setResources(GAQLresources.default);
      setLoading(false);
    })();
  }, []);
  return {
    resources,
    loading,
  };
};
